const chat = {
  composer: {
    inputAriaLabel: 'Entrada de mensaje',
    placeholder: 'Pregunte sobre tendencias de seguridad, conductores e incidentes... escriba \'help\' para obtener ayuda.',
    sendMessage: 'Enviar mensaje',
  },
  copyMarkdown: {
    action: 'Copiar Markdown',
    copied: 'Copiado',
    title: 'Copiar Markdown sin formato al portapapeles',
  },
  citations: {
    summary_one: 'Fuente de datos ({{count}})',
    summary_other: 'Fuentes de datos ({{count}})',
  },
  errors: {
    authenticationFailed: 'La autenticación falló. Inicie sesión de nuevo.',
    authenticationHint: 'Compruebe que sus credenciales de inicio de sesión son correctas e inténtelo de nuevo.',
    dismiss: 'Descartar error',
    loginRequired: 'Inicie sesión para enviar mensajes.',
    messageWithHint: '{{message}}\n\n**Sugerencia:** {{hint}}',
    networkFailed: 'Falló la conexión de red. Compruebe su conexión a Internet e inténtelo de nuevo.',
    networkHint: 'Compruebe que tiene una conexión a Internet estable y que el servidor de SpeedGauge es accesible.',
    requestFailed: 'No se pudo enviar su mensaje. Inténtelo de nuevo.',
    serverHint: 'El servidor puede no estar disponible temporalmente. Inténtelo de nuevo en unos momentos.',
    sessionCreating: 'Se está creando su sesión. Espere un momento e inténtelo de nuevo.',
    sessionExpired: 'Su sesión expiró por inactividad. Inicie sesión de nuevo para continuar.',
    sessionExpiredHint: 'Su sesión finalizó después de 24 horas de inactividad. Esto es normal por motivos de seguridad.',
  },
  feedback: {
    cancel: 'Cancelar',
    characterCount: '{{count}} / {{maximum}}',
    close: 'Cerrar modal de comentarios',
    commentTooLong_one: 'Los comentarios deben tener {{formattedMaximum}} caracteres o menos. Elimine {{formattedCount}} carácter.',
    commentTooLong_other: 'Los comentarios deben tener {{formattedMaximum}} caracteres o menos. Elimine {{formattedCount}} caracteres.',
    commentsLabel: 'Comentarios adicionales (opcionales)',
    commentsPlaceholder: 'Comparta cualquier comentario específico para ayudarnos a mejorar...',
    helpful: 'Útil',
    helpfulAriaLabel: 'Pulgar arriba - Útil',
    helpfulTitle: 'Esta respuesta fue útil',
    notHelpful: 'Poco útil',
    notHelpfulAriaLabel: 'Pulgar abajo - Poco útil',
    notHelpfulTitle: 'Esta respuesta no fue útil',
    remainingCharacters_one: '{{count}} carácter restante',
    remainingCharacters_other: '{{count}} caracteres restantes',
    ratingQuestion: '¿Cómo calificaría esta respuesta?',
    reduceToSubmit: 'Reduzca la longitud de los comentarios para enviarlos',
    submit: 'Enviar comentarios',
    submitFailed: 'No se pudieron enviar los comentarios. Inténtelo de nuevo.',
    submitting: 'Enviando...',
    title: 'Comentarios sobre el mensaje',
  },
  history: {
    cancelDelete: 'Cancelar',
    close: 'Cerrar',
    closeTitle: 'Cerrar sesión',
    confirmDelete: 'Confirmar',
    confirmDeleteTitle: 'Confirmar eliminación',
    delete: 'Eliminar sesión',
    deleteFailed: 'No se pudo eliminar esta sesión. Inténtelo de nuevo.',
    deleteTitle: 'Eliminar sesión',
    empty: 'Todavía no hay historial de chat',
    invalidDate: 'Fecha no válida',
    invalidTime: 'Hora no válida',
    loading: 'Cargando...',
    loadingChat: 'Cargando chat',
    showMore: 'Mostrar más',
  },
  messageList: {
    ariaLabel: 'Mensajes de chat',
  },
  map: {
    loading: 'Cargando mapa...',
  },
  messages: {
    ariaLabel: 'Mensaje del {{role}}',
    assistant: 'asistente',
    user: 'usuario',
    you: 'Usted',
  },
  status: {
    initializing: 'Inicializando...',
    initializingAriaLabel: 'Inicializando el chat',
    thinking: 'Pensando...',
    thinkingAriaLabel: 'El asistente está pensando',
  },
  suggestions: {
    ariaLabel: 'Sugerencias de Coach',
    generatedAriaLabel: 'Sugerencias de seguimiento generadas',
    empty: 'Aún no hay sugerencias de Coach disponibles.',
    loading: 'Cargando las sugerencias de Coach...',
    rightPanel: 'Prueba a preguntarle a Coach',
    send: 'Enviar {{title}}',
    unavailable: 'Las sugerencias de Coach no están disponibles temporalmente.',
  },
  streamEvents: {
    complete: 'Completado',
    event: 'Evento',
    latest: 'Último evento: {{label}}',
    reasoning: 'Razonamiento',
    response: 'Respuesta iniciada',
    sessionDocument: 'Documento de sesión',
    streamingResponse: 'Respuesta en curso',
    toolUse: 'Usando una herramienta',
    toolUseWithName: 'Uso de herramienta: {{name}}',
    toolResult: 'Resultado de herramienta',
    toolResultWithName: 'Resultado de herramienta: {{name}}',
    update: 'Actualizando',
  },
  welcome: {
    newUser: '¡Hola! Soy SpeedGauge Coach AI.\n\n¿Cómo puedo ayudarle?',
    returning: {
      driverData: '¡Bienvenido de nuevo! ¿Listo para analizar los datos de sus conductores?',
      explore: '¡Es bueno tenerle de vuelta! ¿Qué le gustaría explorar?',
      goodToSeeYou: '¡Me alegra verle! ¿Cómo puedo ayudarle?',
      helloAgain: '¡Hola de nuevo! ¿Cómo puedo ayudarle?',
      insights: '¡Bienvenido de nuevo! ¿Qué información puedo ayudarle a descubrir?',
      readyToHelp: '¡Hola! ¿Qué puedo hacer por usted hoy?',
      welcome: '¡Bienvenido! ¿Qué le gustaría saber?',
      welcomeBack: '¡Bienvenido de nuevo! ¿En qué puedo ayudarle hoy?',
    },
  },
} as const;

export default chat;